import "./Home.scss";

export function Home() {
  return (
    <div className="home-page">
      <div className="message">
        <div>
          <div className="dotted-outline"></div>
          <div className="colourful-square"></div>
        </div>

        <h1>abby's homepage</h1>

        <p>under construction</p>
        <small>subject to delays</small>

        <br />

        <p className="contact">
          if you wanna talk to me, im @abbyfour on discord
        </p>
      </div>
    </div>
  );
}
